import api from './api';

export interface Content {
  id: string;
  workspace_id: string;
  campaign_id?: string;
  title: string;
  content_type: string;
  content?: string;
  status: string;
  platform?: string;
  scheduled_date?: string;
  published_date?: string;
  performance_metrics?: any;
  created_at: string;
}

export interface ContentGenerationRequest {
  content_type: string;
  topic: string;
  tone?: string;
  length?: string;
  target_audience?: string;
  keywords?: string[];
  platform?: string;
}

export const contentService = {
  getContent: async (filters?: any) => {
    const response = await api.get('/content', {
      params: filters,
    });
    return response.data;
  },

  getContentItem: async (id: string) => {
    const response = await api.get(`/content/${id}`);
    return response.data;
  },

  generateContent: async (request: ContentGenerationRequest) => {
    const response = await api.post('/content/generate', request);
    return response.data;
  },

  createContent: async (data: Partial<Content>) => {
    const response = await api.post('/content', data);
    return response.data;
  },

  updateContent: async (id: string, data: Partial<Content>) => {
    const response = await api.put(`/content/${id}`, data);
    return response.data;
  },

  deleteContent: async (id: string) => {
    const response = await api.delete(`/content/${id}`);
    return response.data;
  },

  optimizeContent: async (id: string, platform: string) => {
    const response = await api.post(`/content/${id}/optimize`, { platform });
    return response.data;
  },

  repurposeContent: async (id: string, targetPlatforms: string[]) => {
    const response = await api.post(`/content/${id}/repurpose`, {
      target_platforms: targetPlatforms,
    });
    return response.data;
  },

  scheduleContent: async (id: string, scheduledDate: string, platform: string) => {
    const response = await api.post(`/content/${id}/schedule`, {
      scheduled_date: scheduledDate,
      platform,
    });
    return response.data;
  },

  publishContent: async (id: string, platform: string) => {
    const response = await api.post(`/content/${id}/publish`, { platform });
    return response.data;
  },

  checkCompliance: async (id: string) => {
    const response = await api.post(`/content/${id}/compliance-check`);
    return response.data;
  },

  generateImage: async (prompt: string, aspectRatio?: string) => {
    const response = await api.post('/content/generate-image', {
      prompt,
      aspect_ratio: aspectRatio,
    });
    return response.data;
  },
};
